<template>
  <div id="app">
    <div ref="optHeaderRef" />
    <div class="arcopen-nav-white"></div>
    <router-view class="app-body"></router-view>
    <company-dialog class="company-dialog"></company-dialog>
    <bottom-footer v-if="showFooter" class="bottom-footer"></bottom-footer>
    <div class="helper-center">
      <div class="enter-wrp">
        <img src="./assets/ic_help.png" alt="">
        <p>帮助中心</p>
      </div>
      <div class="toggle">
        <p class="toggle-item">
          <a href="//openhome.bilibili.com/doc/4/e9a4bc66-473c-3a32-2658-db94ae6513fe" target="_blank"
            @click="$LogReport.sendCustomEvent('openplat_contactus_click')">
            <img src="./assets/ic_contact.png" alt="">
            <span>联系我们</span>
          </a>
        </p>
        <p class="toggle-item">
          <a :href='ticketUrl' target="_blank">
            <img src="./assets/ic_create.png" alt="">
            <span>发起工单</span>
          </a>
        </p>
      </div>
    </div>
    <backTop />

  </div>
</template>

<script>
// import ArcopenNav from './nav'
import { EsOptHeader } from '@bilibili-live/opt-header'
import CompanyDialog from '@/components/index/CompanyDialog'
import backTop from '@/components/backTop'
import BottomFooter from './footer'
const optHeader = new EsOptHeader()

export default {
  name: 'App',
  created() { },
  components: {
    CompanyDialog,
    BottomFooter,
    backTop
  },
  mounted() {
    optHeader.mount(this.$refs.optHeaderRef)
  },
  destroyed() {
    optHeader.destroy()
  },
  methods: {
  },
  computed: {
    showFooter() {
      if (this.$route.name === 'docCollection') {
        return false
      } else {
        return true
      }
    },
    ticketUrl() {
      return `//${window.$bili_arcopen.isUAT ? 'uat-' : ''}openhome.bilibili.com/ticket`
    }
  }
}
</script>

<style lang="scss">
#app {
  height: 100vh;
  width: 100%;
  margin: 0 auto;
  min-width: 1025px;
}

.app-body {
  min-height: calc(100% - 64px - 144px);
  box-sizing: border-box;
}

.bcc-button {
  padding: 10px 24px !important;
}

.bcc-input .bcc-input-inner.input {
  height: 38px !important;
}

.bcc-input .word-limit {
  bottom: 11px !important;
}

@media screen and (max-width: 768px) {
  #app {
    min-width: 0 !important;
    ;
  }

  .arcopen-nav,
  .bottom-footer,
  .arcopen-nav-white,
  .company-dialog {
    display: none !important;
  }
}

.helper-center {
  bottom: 25%;
  right: 0;
  position: fixed;
  padding-left: 20px;

  &:hover {
    .toggle {
      display: block;
    }
  }

  .toggle {
    display: none;
    width: 154px;
    box-sizing: border-box;
    padding: 8px;
    border: 4px solid #F7FBFF;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 80px;
    background-color: #ffffff;
    height: 120px;

    &:after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      border-top: 4px solid #F7FBFF;
      border-right: 4px solid #F7FBFF;
      background-color: #ffffff;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: -10px;
      transform: rotate(45deg);
    }

    .toggle-item {
      user-select: none;
      font-size: 16px;
      color: #666666;
      line-height: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      margin-left: 10px;
      cursor: pointer;
      border-bottom: 1px solid #e7e7e7;
      padding-bottom: 2px;

      &:last-child {
        border: none;
      }

      a {
        color: #666666;
        display: flex;
        align-items: center;
      }

      &:hover {
        color: #00A1D6;

        a {
          color: #00A1D6;
        }
      }

      img,
      span {
        vertical-align: middle;
      }

      img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
    }
  }

  .enter-wrp {
    width: 68px;
    height: 98px;
    background: #FFFFFF;
    box-shadow: 0 4px 16px 0 rgba(223, 226, 237, 0.50);
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    color: #999999;

    &:hover {
      background: #F7FBFF;
      color: #00A1D6;
    }

    img {
      height: 24px;
      width: auto;
      margin: 14px 8px 8px;
    }

    p {
      width: 50%;
      margin: auto;
      letter-spacing: 2px;
      line-height: 16px;
    }
  }
}
</style>
